import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SideBar from "../../../common/SideBar";
import HeaderBar from "../../../common/HeaderBar";
import SetQuiz from "./SetQuiz";
import QuizSummaryBar from "./QuizSummaryBar";
import QuizPreviewModal from "./QuizPreviewModal";
import { getSubjectChapter } from "../../../../Redux/test/test.action";
import "./createQuiz.scss";
import ToastMessage from "../../../../utils/toasts/toastMessage";
import {
  assignmentHistory,
  createAllAssignment,
  deleteQuizAssignment,
} from "../../../../Redux/Teacher_Panel/Teacher_Resource/resource.action";
import { Loader } from "lucide-react";

const CreateQuiz = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showQuizModal, setShowQuizModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [quizList, setQuizList] = useState([]);
  const [selectedPreviewData, setSelectedPreviewData] = useState(null);
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedAssignmentId, setSelectedAssignmentId] = useState(null);
   const [loadingFinalize, setLoadingFinalize] = useState(false);

  const [loading, setLoading] = useState(false);
  const [toastState, setToastState] = useState({ show: false, message: "", type: "" });

  const store=useSelector((state) => state);

  const subjectChapters = useSelector((state) => state?.TestManager?.subjectChapter);
  const resourceStore = useSelector((state) => state?.CreateResourceManager?.assignment_history?.assignments);

    console.log(resourceStore,"resourceStore")

  useEffect(() => {
    dispatch(getSubjectChapter());
    dispatch(assignmentHistory());
  }, [dispatch]);

  const quizListData = useMemo(() => {
    return resourceStore?.filter((item) => item?.is_assigned === false) || [];
  }, [resourceStore]);

  useEffect(() => {
    if (quizListData) setQuizList(quizListData);
  }, [quizListData]);

  // 1. Open Create Modal
  const handleOpenCreateModal = () => {
    setShowQuizModal(true);
    setIsEditing(false);
  };

  // 2. Handle Data from SetQuiz (Add to List)
  const handleQuizCreated = (data) => {
    setShowQuizModal(false);
  };

  const handleDelete = (e, assignmentId) => {
    e.preventDefault();
    setSelectedAssignmentId(assignmentId);
    setShowConfirmModal(true);
  };

  const handleConfirmDelete = async () => {
    setLoading(true)
    const payload = {
      assignment_id: selectedAssignmentId,
    };

    const result = await dispatch(deleteQuizAssignment(payload));

    if (!result.success) {
      setLoading(false);
      setToastState({
        show: true,
        message: result.message || "Something went wrong!",
        type: "error",
      });
    } else {
       setShowConfirmModal(false);
        setToastState({
        show: true,
        message: "selected assignment deleted successfully.",
        type: "error",
      });
      dispatch(assignmentHistory());
      setLoading(false);
    }
  };

  const handleEdit = (quiz) => {
    setSelectedQuiz(quiz);
    setShowQuizModal(true);
    setIsEditing(true);
  };

  const buildPayload = (data) => {
    return {
      assignment_ids: data?.map((item) => String(item.assignment_id)) || [],
    };
  };

  const handleCreateAll = async () => {
    setLoadingFinalize(true);
    const payload = buildPayload(quizList);

    const result = await dispatch(createAllAssignment(payload));

    if (!result.success) {
      setLoadingFinalize(false);
      setToastState({
        show: true,
        message: result.message || "Something went wrong! Try again.",
        type: "error",
      });
    } else {
      setLoadingFinalize(false);
      setToastState({
        show: true,
        message: "Assignment created successfully.",
        type: "success",
      });
      dispatch(assignmentHistory());
      // navigate("/test");
    }
  };

  return (
    <main className="ff2 main-page">
      <HeaderBar />
      <div className="overflow-hidden inner-page-content">
        <SideBar />

        <div className="create-selection-container">
          {quizList?.length > 0 ? (
            <div className="quiz-list-wrapper">
              <div className="sticky-header-section">
                <h5>Scheduled Assessments: {quizList?.length}</h5>
                <div className="button-group">
                  <button className="btn-history" onClick={() => navigate("/assessment-history")}>
                    📊 Check Assessment History
                  </button>
                  <button className="btn-add-test" onClick={handleOpenCreateModal}>
                    + Add Another Test
                  </button>
                </div>
              </div>

              <div className="scrollable-content-box">
                <div className="list-gap-wrapper">
                  {quizList?.map((quiz) => (
                    <QuizSummaryBar
                      key={quiz.id}
                      data={quiz}
                      onEdit={() => handleEdit(quiz)}
                      onDelete={(e) => handleDelete(e, quiz?.assignment_id)}
                      onPreview={() => {
                        setSelectedPreviewData(quiz);
                        setShowPreviewModal(true);
                      }}
                    />
                  ))}
                </div>
              </div>

              <div className="fixed-footer-action">
                <button
                  className="btn btn-link text-muted me-4"
                  disabled={loadingFinalize}
                  onClick={() => setQuizList([])}
                >
                  Cancel & Reset
                </button>
                <button
                  className="btn btn-success fw-bold px-5 py-2"
                  disabled={loadingFinalize}
                  onClick={handleCreateAll}
                >
                  {loadingFinalize ? (
                    <>
                      <Loader size={20} className="animate-spin-custom me-2" />
                      <span>Finalizing...</span>
                    </>
                  ) : (
                    "Finalize All Tests"
                  )}
                </button>
              </div>
            </div>
          ) : (
            <div className="empty-state-wrapper">
              <div className="empty-state-header">
                <h2 className="title">What would you like to create?</h2>
                <button className="btn-history" onClick={() => navigate("/assessment-history")}>
                  📊 Check Assessment History
                </button>
              </div>
              
              <div className="cards-wrapper">
                <div className="selection-card test-card" onClick={handleOpenCreateModal}>
                  <div className="icon">📝</div>
                  <h5>Create Test</h5>
                  <p>Create new assessments and tests</p>
                </div>

                <div className="selection-card course-card" onClick={() => navigate("/create-course")}>
                  <div className="icon">📖</div>
                  <h5>Create Course</h5>
                  <p>Build learning courses</p>
                </div>
              </div>
            </div>
          )}
        </div>
          {showConfirmModal && (
            <div
              className="modal fade show"
              tabIndex={-1}
              aria-hidden="true"
              style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="border-0 bdrs40 modal-content p-4 text-center">
                  <button
                    type="button"
                    className="btn-close position-absolute end-0 top-0 m-3"
                    onClick={() => setShowConfirmModal(false)}
                  />

                  <h4 className="fw600 mb-3">Delete</h4>

                  <p className="mb-4">
                    Are you sure you want to delete the test?
                  </p>

                  <div className="d-flex justify-content-center gap-3">
                    <button
                      className="btn btn-outlined btn-outlined--dark px-4"
                        onClick={() => setShowConfirmModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-outlined btn-outlined--dark px-4"
                   
                       onClick={handleConfirmDelete}
                    >
                         Delete
                   
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        <ToastMessage
          show={toastState.show}
          onClose={() => setToastState({ show: false, message: "", type: "" })}
          message={toastState.message}
          type={toastState.type}
        />
      </div>

      <SetQuiz
        show={showQuizModal}
        onHide={() => setShowQuizModal(false)}
        subjectChapters={subjectChapters}
        onCreate={handleQuizCreated}
        quizData={selectedQuiz}
        editing={isEditing}
      />

      <QuizPreviewModal
        show={showPreviewModal}
        onHide={() => setShowPreviewModal(false)}
        data={selectedPreviewData}
      />
    </main>
  );
};

export default CreateQuiz;